"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKNumericInput = void 0;
var react_1 = __importDefault(require("react"));
var gds_ux_components_1 = require("@granular/gds-ux-components");
var common_1 = require("@granular/gds-ux-components/lib/common");
var hooks_1 = require("@granular/gds-ux-components/lib/common/hooks");
var numberfield_1 = require("@react-aria/numberfield");
var button_1 = require("@react-aria/button");
var i18n_1 = require("@react-aria/i18n");
var numberfield_2 = require("@react-stately/numberfield");
var useBetaMessaging_1 = __importDefault(require("../../common/useBetaMessaging"));
var GKNumericInput = function (props) {
    // We're in beta.
    (0, useBetaMessaging_1.default)({
        name: "GKNumericInput",
        status: "active",
        releaseDate: "TBD",
        removeDate: "TBD",
        docsAt: "https://design.granular.ag/design-system/components/numericinput",
    });
    // Grab the locale from the browser
    var parentLocale = (0, i18n_1.useLocale)().locale;
    // Split out props we'll use/modify internally
    var _a = (0, common_1.mapDefaultProps)(props, {
        _gkComponentName: "gk-numeric-input",
    }), className = _a.className, qaProp = _a["data-qa"], disabled = _a.disabled, id = _a.id, invalid = _a.invalid, _b = _a.locale, locale = _b === void 0 ? parentLocale : _b, readOnly = _a.readOnly, required = _a.required, showSteppers = _a.showSteppers, style = _a.style, valid = _a.valid, placeholder = _a.placeholder, onChange = _a.onChange, inputPassthroughProps = __rest(_a, ["className", "data-qa", "disabled", "id", "invalid", "locale", "readOnly", "required", "showSteppers", "style", "valid", "placeholder", "onChange"]);
    // Set up our refs
    var inputRef = react_1.default.useRef(null);
    var incrementRef = react_1.default.useRef(null);
    var decrementRef = react_1.default.useRef(null);
    // Set up our custom passthroughs, ids, classNames, etc
    var myID = (0, hooks_1.usePersistentId2)(id);
    var groupPassthroughProps = {
        className: className,
        "data-qa": qaProp,
        id: myID,
        style: style,
    };
    var inputClassNames = [
        "form-control",
        invalid && "is-invalid",
        valid && "is-valid",
    ]
        .filter(function (c) { return c; })
        .join(" ");
    var ariaLabel = props.label ? myID + "--label" : undefined;
    // Set up useNumberField and get out props back
    var numState = (0, numberfield_2.useNumberFieldState)(__assign(__assign({}, inputPassthroughProps), { locale: locale }));
    var _c = (0, numberfield_1.useNumberField)(__assign(__assign({}, inputPassthroughProps), { isDisabled: disabled, isReadOnly: readOnly, isRequired: required, id: myID + "--input" }), numState, inputRef), decrementButtonProps = _c.decrementButtonProps, incrementButtonProps = _c.incrementButtonProps, inputProps = _c.inputProps, labelProps = _c.labelProps;
    // Set up the increment/decrement buttons
    var doStep = showSteppers !== null && showSteppers !== void 0 ? showSteppers : props.step !== undefined;
    var incrementProps = (0, button_1.useButton)(incrementButtonProps, incrementRef).buttonProps;
    var decrementProps = (0, button_1.useButton)(decrementButtonProps, decrementRef).buttonProps;
    // Form group context setup/effects
    var _d = react_1.default.useContext(gds_ux_components_1.GKFormGroupContext), setDisabled = _d.setDisabled, setValidation = _d.setValidation, setReadOnly = _d.setReadOnly, setRequired = _d.setRequired;
    /**
     * This is to avoid the execution of the onChange function
     * when the component is mounted.
     */
    var isFirstMount = react_1.default.useRef(true);
    react_1.default.useEffect(function () {
        if (!isFirstMount.current) {
            onChange === null || onChange === void 0 ? void 0 : onChange(numState.numberValue);
        }
        else
            isFirstMount.current = false;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [numState === null || numState === void 0 ? void 0 : numState.numberValue]);
    react_1.default.useEffect(function () {
        setDisabled(disabled);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disabled]);
    react_1.default.useEffect(function () {
        setValidation(props.invalid === true ? false : props.valid === true ? true : undefined);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.invalid, props.valid]);
    react_1.default.useEffect(function () {
        setReadOnly(readOnly);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [readOnly]);
    react_1.default.useEffect(function () {
        setRequired(required);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [required]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        props.label && (react_1.default.createElement(gds_ux_components_1.GKLabel, __assign({}, labelProps, { id: ariaLabel }), props.label)),
        react_1.default.createElement(gds_ux_components_1.GKInputGroup, __assign({}, groupPassthroughProps),
            doStep && (react_1.default.createElement(gds_ux_components_1.GKInputGroupAddon, { addonType: "prepend" },
                react_1.default.createElement(gds_ux_components_1.GKButton, __assign({}, decrementProps, { innerRef: decrementRef, "data-qa": qaProp + "--decrement" }),
                    react_1.default.createElement(gds_ux_components_1.GKIcon, { name: gds_ux_components_1.GKIconName.Remove })))),
            react_1.default.createElement("input", __assign({}, inputProps, { ref: inputRef, className: inputClassNames, "data-qa": qaProp + "--input", "aria-labelledby": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : inputProps["aria-labelledby"], placeholder: placeholder })),
            doStep && (react_1.default.createElement(gds_ux_components_1.GKInputGroupAddon, { addonType: "append" },
                react_1.default.createElement(gds_ux_components_1.GKButton, __assign({}, incrementProps, { innerRef: incrementRef, "data-qa": qaProp + "--increment" }),
                    react_1.default.createElement(gds_ux_components_1.GKIcon, { name: gds_ux_components_1.GKIconName.Add })))))));
};
exports.GKNumericInput = GKNumericInput;
